import React, { useState } from "react";
import Popper from "@material-ui/core/Popper";
import Fade from "@material-ui/core/Fade";
import Paper from "@material-ui/core/Paper";

import Box from "@mui/material/Box";
import Tooltip from "@material-ui/core/Tooltip";
import "remixicon/fonts/remixicon.css";
import { filtersItems } from "./utils";
import Grid from "@material-ui/core/Grid";
import {
  styleFilterIcon,
  styleFilterIconButton,
  styleGridContainer,
  styleIconGrid,
  styleIconsFilters,
} from "./styles";
import { WrapperLegend } from "../../../../../../../../../components/StyledComponents";

export const TableFilters = ({ filters, setFilters, setPaginationFilters }) => {
  const [filterOpened, setFilterOpened] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleIconFilters = (filter, value) => {
    setPaginationFilters({
      page: 0,
      linesPerPage: 10,
      orderBy: "id",
      direction: "DESC",
    });
    setFilters(filter, value);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setFilterOpened((prev) => !prev);
  };

  return (
    <WrapperLegend>
      <Popper
        open={filterOpened}
        anchorEl={anchorEl}
        placement={"bottom-end"}
        transition
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper style={{ width: 153 }}>
              <Grid container style={styleGridContainer}>
                {filtersItems
                  .filter(
                    (item) => filters?.[item.filterKey] !== item.filterValue
                  )
                  .map((item, index) => (
                    <Grid item xs={3} key={index} style={styleIconGrid}>
                      <Box
                        style={styleIconsFilters(false)}
                        className="legenda-buttons"
                        onClick={() =>
                          handleIconFilters(item.filterKey, item.filterValue)
                        }
                      >
                        <Tooltip title={item.tooltip}>
                          {item.icon(false)}
                        </Tooltip>
                      </Box>
                    </Grid>
                  ))}
                {filtersItems
                  .filter(
                    (item) => filters?.[item.filterKey] === item.filterValue
                  )
                  .map((item, index) => (
                    <Grid item xs={3} key={index} style={styleIconGrid}>
                      <Box
                        style={styleIconsFilters(true)}
                        className="legenda-buttons"
                        onClick={() =>
                          handleIconFilters(item.filterKey, item.filterValue)
                        }
                      >
                        <Tooltip title={item.tooltip}>
                          {item.icon(true)}
                        </Tooltip>
                      </Box>
                    </Grid>
                  ))}
              </Grid>
            </Paper>
          </Fade>
        )}
      </Popper>
      <Grid container justifyContent="flex-end">
        {filtersItems
          .filter((item) => filters?.[item.filterKey] === item.filterValue)
          .map((item, index) => (
            <Grid item key={index} style={styleIconGrid}>
              <Box
                style={styleIconsFilters(false, true)}
                className="legenda-buttons"
              >
                <Tooltip title={item.tooltip}>{item.icon(false)}</Tooltip>
              </Box>
            </Grid>
          ))}
        <Grid item style={styleIconGrid}>
          <Box
            style={styleFilterIconButton(filterOpened)}
            className="legenda-buttons"
            onClick={handleClick}
          >
            <Tooltip title="Filtrar">
              <i className="ri-more-2-fill" style={styleFilterIcon} />
            </Tooltip>
          </Box>
        </Grid>
      </Grid>
    </WrapperLegend>
  );
};
